<template>
  <div class="tab-content d-flex justify-space-between align-start">
    <div class="tab-content-text d-flex flex-column ga-8">
      <div class="d-flex flex-column ga-4">
        <h2 class="title-medium">Checkpoint</h2>
        <div class="d-flex flex-column ga-4">
          <v-checkbox v-model="localData.checkpointStatus" class="px-4 align-checkbox-start" hide-details>
            <template v-slot:label>
              <div class="d-flex ">
                <span>Ao ativar esta funcionalidade, a Plataforma Rubeus registrará eventos automaticamente sempre que marcos configuráveis forem atingidos na conversa. 
                  <a href="https://crmrubeus.zendesk.com/hc/pt-br/articles/39105067922317-Envio-de-checkpoints-com-o-Rubeus-Assistentes" target="_blank" class="body-medium link"> Saiba mais </a>
                </span>
              </div>
            </template>
          </v-checkbox>
        </div>
      </div>
      <div class="d-flex flex-column ga-4">
        <h2 class="title-medium">Mensagens padrões</h2>
        <p class="body-medium">São mensagens automáticas que serão enviadas aos usuários, sem a utilização de prompts. <b>Não utilize prompts.</b></p>
        <div class="d-flex flex-column ga-4">
          <rb-input v-model="localData.errorMessage" label="Mensagem caso a IA esteja indisponível" hint="Essa mensagem será enviada automaticamente caso o modelo de IA selecionado esteja fora do ar." persistent-hint></rb-input>        
        </div>
      </div>
      <div class="comportamento config-group-title d-flex flex-column ga-4">
        <h2 class="title-medium">Prompts de comportamento*</h2>
        <p class="body-medium">Defina os prompts (instruções) que serão usados para o comportamento do assistente. <a class="link" href="https://crmrubeus.zendesk.com/hc/pt-br/articles/36302559165325-Como-preencher-a-etapa-Comportamento-no-cadastro-de-um-novo-assistente">Saiba mais</a>.</p>
        <div class="comportamento-content d-flex flex-column ga-4">
          <rb-textarea v-model="localData.presentation" rows="3" :rules="[...inputRules.required, ...inputRules.maxLength(4000)]" required
            label="Defina como será a apresentação do assistente *"
            hint='Exemplo: "Um assistente que ajuda as pessoas a alcançarem seus objetivos e desenvolverem suas habilidades."'
            persistent-hint></rb-textarea>
          <rb-textarea v-model="localData.instructions" rows="3" :rules="[...inputRules.required, ...inputRules.maxLength(8000)]" required
            label="Defina instruções claras de comportamento  *"
            hint='Exemplo: Identifique o telefone da pessoa para a equipe entrar em contato; Identifique a data de nascimento da pessoa; Etc.'
            persistent-hint></rb-textarea>
          <rb-textarea v-model="localData.endChat" rows="3" :rules="[...inputRules.required, ...inputRules.maxLength(4000)]" required
            label="Defina quando e como o assistente deve encerrar a conversa *" :hint="assistentEndChatHint"
            persistent-hint></rb-textarea>
        </div>
      </div>
      <div class="d-flex flex-column ga-4">
        <h2 class="title-medium">Padrões comerciais</h2>
        <div class="d-flex flex-column ga-4">
          <rb-textarea v-model="localData.commercial" rows="3" label="Defina os padrões comerciais"
            hint='Exemplo: "Para serviços premium, oferecer até 15% de desconto. Para serviços básicos, até 10%. Apenas mencione os descontos se o usuário perguntar, oferecendo gradualmente de 5% em 5%."'
            persistent-hint></rb-textarea>
        </div>
      </div>
    </div>
    <CardBaseConhecimentos :relatedLinks="relatedLinks"></CardBaseConhecimentos>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import CardBaseConhecimentos from '@/assistents/components/CardBaseConhecimentos.vue';
const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  relatedLinks: {
    type: Array,
    required: true
  },
  inputRules: {
    type: Object,
    required: true
  }
});

const assistentEndChatHint = `Exemplo: "Quando a dúvida do usuário for esclarecida, pergunte: 'Posso ajudar com algo mais?'. Caso não, encerre com: 'Agradecemos por entrar em contato!'"`;

const localData = computed({
  get: () => props.modelValue,
  set: (newValue) => {
    emit('update:modelValue', newValue);
  }
});
</script>

<style lang='scss' scoped>
@use '@/ai_studio/styles/components/assistents-configuration.scss';
</style>